import { isStoreOrOrdersPath } from '@/utils/platformMigrationHelper';

// The V2 migration notice opens once per user and active org. After it is
// closed, the banner stays up as the way back to it (COR-6465).
const DISMISSED_KEY_PREFIX = 'v2MigrationNoticeDismissed:';

export function storedUserId() {
  try {
    const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_ACCESS_TOKEN_NAME + 'User'));
    return (user && (user._id || user.id)) || null;
  } catch (e) {
    return null;
  }
}

function dismissalKey(userId, orgId) {
  if (!userId || !orgId) return null;
  return DISMISSED_KEY_PREFIX + userId + ':' + orgId;
}

export function isMigrationNoticeDismissed(userId, orgId) {
  const key = dismissalKey(userId, orgId);
  if (!key) return false;
  try {
    return localStorage.getItem(key) === 'true';
  } catch (e) {
    return false;
  }
}

export function dismissMigrationNotice(userId, orgId) {
  const key = dismissalKey(userId, orgId);
  if (!key) return;
  try {
    localStorage.setItem(key, 'true');
  } catch (e) {
    // Storage blocked: the notice reopens on the next page load, which is safe.
  }
}

// Store and Orders stay usable without any migration treatment (COR-6510).
export function showsMigrationTreatment(target, path, v2Url) {
  return Boolean(target && target.migrated && v2Url) && !isStoreOrOrdersPath(path);
}
